import { flatMap } from 'lodash'
import { MediaAsset } from 'models/Asset'
import { createSelector } from 'reselect'
import { isImage, isVideo } from 'Util/assets'

export const selectMediaRecordingType = (state: RootState) => state.mainView.showFeatures.mediaRecordingSettings

export const selectPlayerVolume = (state: RootState) => state.mainView.playerVolume as number

export const selectOfflineRestoration = (state: RootState) => state.mainView.offlineRestoration
export const selectMenuItem = createSelector([
  (state: RootState) => state.mainView.menuItem,
], menuItem => menuItem)

export const selectShowSaveSettings = createSelector([
  (state: RootState) => state.mainView.showSaveSettings,
], showSaveSettings => showSaveSettings)

export const selectShowNabletHld = createSelector([
  (state: RootState) => state.mainView.showNabletHldSettings,
], showNabletHldSettings => showNabletHldSettings)

export const selectShowCustomizeView = createSelector([
  (state: RootState) => state.mainView.showCustomizeView,
], showCustomizeView => showCustomizeView)

export const selectShowImportFromUrl = createSelector([
  (state: RootState) => state.mainView.showImportFromUrl,
], showImportFromUrl => showImportFromUrl)

export const selectActiveDragElement = createSelector([
  state => state.mainView.activeDragElement,
], activeDragElement => activeDragElement)

export const selectShowEditorSettings = createSelector([
  (state: RootState) => state.mainView.showEditorSettings,
], showEditorSettings => showEditorSettings)

export const selectShowReferenceFileChoice = createSelector([
  (state: RootState) => state.mainView.showReferenceFileChoice,
], showReferenceFileChoice => showReferenceFileChoice)

export const selectShowDeleteMediaFilesForm = createSelector([
  (state: RootState) => state.mainView.showDeleteMediaFilesForm,
], showDeleteMediaFilesForm => showDeleteMediaFilesForm)

export const selectShowLogActions = createSelector([
  (state: RootState) => state.mainView.showLogActions,
], showLogActions => showLogActions)

export const selectSelectedSourceMediaFileIds = createSelector([
  (state: RootState) => state.mainView.referenceFilesData,
], referenceFilesData => referenceFilesData.map(file => file.id))

export const selectReferenceFilesData = createSelector([
  (state: RootState) => state.sourceFiles,
  (state: RootState) => state.mainView.referenceFilesData,
], (sourceFiles, referenceFilesData) => {
  const ids = referenceFilesData.map(file => file.id)
  return flatMap((Object.values(sourceFiles) as unknown as Array<{ items: MediaAsset[] }>), x => x.items)
    .filter(x => ids.includes(x?.id) && (isVideo(x) || isImage(x)))
})

export const selectEditorSettings = createSelector([
  (state: RootState) => state.mainView.editorSettings,
], editorSettings => editorSettings)

export const selectRenderSettings = createSelector([
  (state: RootState) => state.mainView.editorSettings,
], editorSettings => editorSettings.render_settings)

export const selectBehaviourSettings = createSelector([
  (state: RootState) => state.mainView.editorSettings,
], editorSettings => editorSettings.behaviour_settings)

export const selectDragElementBounds = createSelector([
  state => state.mainView.dragElementBounds,
], dragElementBounds => dragElementBounds as DOMRect)
